import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import { Screens } from './index.model';
//import { Http_Header_Request_Options } fr
import * as ApiConfig from '../core/apiconfig';'../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class LocalDataService {

    private apiUrl: string;
    private webapiUrl: string;
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = 'api/screens';
        this.webapiUrl = ApiConfig.API_URL;
    }

    getScreen() {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    getScreens(): Promise<Screens[]> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json().data;
            })
            .catch(this.handleError);
    }

    getScreensdetail(): Promise<Screens[]> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.webapiUrl+"screen/GetScreenDetail", this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json();
            })
            .catch(this.handleError);
    }
    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/localdata.service.ts